export default "__VITE_ASSET__CG_vB3d___"